import { Box, Button, styled, Typography } from "@mui/material";
import UnavailableContentIllustration from "assets/illustrations/UnavailableContentIllustration";
import svgImage from "assets/logo/LoginBackground.png";
import useLocales from "hooks/useLocales";
import { useNavigate } from "react-router";

export const SectionStyle = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  backgroundImage: `url(${svgImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "99%",
}));

const Page403 = () => {
  const { translate } = useLocales();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${svgImage})`,
        alignItems: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h2" sx={{ mt: 8 }}>
          {translate(`403`)}
        </Typography>
        <Typography variant="h4" sx={{ mt: 2 }}>
          {translate(`access_forbidden`)}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <UnavailableContentIllustration />
        </Box>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {translate(`you_dont_have_permission_to_access_this_page`)}
        </Typography>
        <Button
          onClick={() => navigate("/")}
          variant="contained"
          sx={{
            "&:hover": {
              color: "white",
            },
            mt: 2,
          }}
        >
          {translate("go_to_homepage")}
        </Button>
      </Box>
    </Box>
  );
};

export default Page403;
